export default __webpack_public_path__ + "6082b1b920ad58e8af732e6ee3aef11e.png";